import { bostaHttp } from 'http.js';
import { sllrHttp } from 'http.js';

export const submitStoreLink = (payload) => {
  return bostaHttp.post(`/businesses/sllr/submitStoreLink`, payload);
};

export const getStoreLinkSuggestions = (payload) => {
  return bostaHttp.post(`/sllr/businesses/suggestedLinks`, payload);
};

export const updateBusinessStoreInfo = (data, id) => {
  return bostaHttp.put(`/businesses/${id}`, data);
};

export const getAllProducts = (payload) => {
  return bostaHttp.get('/sllr/products', payload);
};

export const getProductsWithVariants = (payload) => {
  return bostaHttp.post('/sllr/products/list', payload);
};

export const getProductData = (id) => {
  return bostaHttp.get(`/sllr/products/${id}`);
};

export const getProductDetails = (id) => {
  return bostaHttp.get(`/sllr/products/overview/${id}`);
};

export const getProductAvailability = (id) => {
  return bostaHttp.get(`/sllr/products/${id}/availability`);
};

export const updateProduct = (id, payload) => {
  return bostaHttp.put(`/sllr/products/${id}`, payload);
};

export const deleteProduct = (id) => {
  return bostaHttp.delete(`/sllr/products/${id}`);
};

export const deleteManyProducts = (payload) => {
  return bostaHttp.delete('/sllr/products/deleteMany', payload);
};

export const getVariants = (id) => {
  return bostaHttp.get(`/sllr/products/${id}/variancesOverview`);
};

export const activateVariant = (variantId, payload) => {
  return bostaHttp.put(
    `/sllr/products/variance-activate/${variantId}`,
    payload
  );
};

export const createMultipleProducts = (payload) => {
  return bostaHttp.post(`/sllr/products/bulk`, payload);
};

export const multiActivate = (payload) => {
  return bostaHttp.put(`/sllr/products/activate`, payload);
};

export const createNewProduct = (payload) => {
  return bostaHttp.post('/sllr/products', payload);
};

export const getProductCategories = ({
  businessId,
  usedOnly = false,
  payload
}) => {
  return bostaHttp.get(
    `/sllr/productCategories/business/${businessId}${
      usedOnly && '/usedCategories'
    }`,
    payload
  );
};

export const createProductCategory = (payload) => {
  return bostaHttp.post(`/sllr/productCategories`, payload);
};

export const getSllrAnalytics = (payload) => {
  return sllrHttp.get('/analytics/v2', payload);
};

export const reorderProduct = (id, payload) => {
  return bostaHttp.put(`/sllr/products/product-order/${id}`, payload);
};

export const getMetaCatalog = () => {
  return sllrHttp.post(`/plugins/meta-feed`);
};

export const validateProductVideo = (payload) => {
  return bostaHttp.post(`/sllr/products/validate/video-url`, payload);
};

export const createSizeChart = (payload) => {
  return bostaHttp.post(`/sllr/products/size-charts`, payload);
};

export const getSizeCharts = () => {
  return bostaHttp.get(`/sllr/products/size-charts/list/all`);
};

export const deleteSizeChart = (id) => {
  return bostaHttp.delete(`/sllr/products/size-charts/${id}`);
};

export const getSizeChart = (id) => {
  return bostaHttp.get(`/sllr/products/size-charts/${id}`);
};

export const updateSizeChart = (id, payload) => {
  return bostaHttp.put(`/sllr/products/size-charts/${id}`, payload);
};

export const updateBulkProducts = (payload) => {
  return bostaHttp.put(`/sllr/products/update-products/bulk`, payload);
};

export const getProductLocationsQuantities = (id) => {
  return sllrHttp.get(`/products/v2/${id}/locations-quantities`);
};

export const createSubCategory = (categoryId, payload) => {
  return sllrHttp.post(
    `/productCategories/${categoryId}/sub-category`,
    payload
  );
};

export const editSubCategory = (subCategoryId, payload) => {
  return sllrHttp.put(
    `/productCategories/sub-category/${subCategoryId}`,
    payload
  );
};

export const deleteSubCategory = (subCategoryId) => {
  return sllrHttp.delete(`/productCategories/sub-category/${subCategoryId}`);
};

export const exportProducts = (payload) => {
  return sllrHttp.post('/products/export/xlsx', payload);
};
